import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { getAlbumCustomPrintCartItem } from '../../../../../services/checkout/redux/helpers';
import AlbumCustomPrintOption from '../AlbumCustomPrintOption';
import { hasPurchasedAlbumFolderIdentity } from '../../helpers';
import { hasSubscriptionInCart } from '../../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasingOptions/helpers';

const propTypes = {
  activeIdentity: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  selectedIdentity: PropTypes.shape({
    id: PropTypes.string,
  }),
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    prepaid_photo_print_packages_enabled: PropTypes.bool,
  }).isRequired,
  albumCustomPrints: PropTypes.array,
  onAlbumCustomPrintToggle: PropTypes.func.isRequired,
  cart: PropTypes.object.isRequired,
  onCartItemUpdate: PropTypes.func.isRequired,
  selectedIdentities: PropTypes.array,
};

const AlbumCustomPrintItemsSelector = ({
  activeIdentity,
  albumFolder,
  albumCustomPrints,
  onAlbumCustomPrintToggle,
  cart,
  onCartItemUpdate,
  selectedIdentities,
}) => {
  if (
    !albumCustomPrints ||
    albumCustomPrints?.length === 0 ||
    !albumFolder?.prepaid_custom_prints_enabled
  ) {
    return null;
  }

  const hasPurchasedAlbumFolderSubscription = hasPurchasedAlbumFolderIdentity(
    albumFolder,
    activeIdentity,
    selectedIdentities,
  );

  const subscriptionInCart = hasSubscriptionInCart({
    cart,
    albumFolder,
    identity: activeIdentity,
  });

  return (
    <Fragment>
      <h4 className="mt-2">
        Memory Mates, Collages &amp; Vendor-fulfilled Products
      </h4>
      {albumCustomPrints.map(albumCustomPrint => (
        <AlbumCustomPrintOption
          onAlbumCustomPrintToggle={() =>
            onAlbumCustomPrintToggle({
              albumCustomPrint,
              albumFolder,
              identity: activeIdentity,
              prePaid: true,
            })
          }
          cartItem={getAlbumCustomPrintCartItem(cart, {
            albumCustomPrintId: albumCustomPrint.id,
            identityId: activeIdentity?.id,
          })}
          albumCustomPrint={albumCustomPrint}
          onUpdate={onCartItemUpdate}
          hasSubscriptionInCart={subscriptionInCart}
          subscriptionAvailable={
            albumFolder?.price?.value > 0 &&
            !hasPurchasedAlbumFolderSubscription
          }
        />
      ))}
    </Fragment>
  );
};

AlbumCustomPrintItemsSelector.propTypes = propTypes;

export default AlbumCustomPrintItemsSelector;
